import axiosInstance from 'api/axiosInstance'

type VaultMediaResponse = {
  data: any[]
  nextPage: number | null
  existingIds: string[]
}


export type GetAllVaultMediaOptions = {
  filter?: string
  sort?: string
  sortAsc?: string
  grouped?: boolean
  mapExistingPostId?: boolean
  offline?: boolean
  show_duplicates?: boolean
  /** SharedMediaModal-only: when true, exclude story entries from results */
  previously_shared?: boolean
  category?: number | null
  type?: string
}

export const getAllVaultMedia = async (
  typeOrFilter: string, // kept same positional arg for compatibility with existing callers
  page: number,
  options?: GetAllVaultMediaOptions
): Promise<VaultMediaResponse> => {
  const opts = options ?? {}
  const { data } = await axiosInstance({
    method: 'GET',
    url: '/api/user/vault',
    params: {
      page: page + 1,

      // Send type (fallback to positional arg)
      type: opts.type ?? typeOrFilter,
      ...opts,

      ...(typeof opts.previously_shared === 'boolean'
        ? { previously_shared: opts.previously_shared }
        : {})
    },
  })

  const items = data.data || []
  const pag = data.pagination || {}
  const nextPage =
    pag.current_page && pag.current_page < pag.last_page ? page + 1 : null

  return {
    data: items,
    nextPage,
    existingIds:
      !!opts.mapExistingPostId && Array.isArray(items)
        ? items.map((i: any) => i.id)
        : [],
  }
}

export type VaultChatDirection = 'incoming' | 'outgoing'

export type SharedVaultFilter =
  | 'all'
  | 'paid'
  | 'unpaid'

export const getSharedVaultMedia = async (
  userId: string,
  page: number,
  options: {
    direction?: VaultChatDirection
    filter?: SharedVaultFilter
    per_page?: number
  } = {}
): Promise<VaultMediaResponse> => {
  const { data } = await axiosInstance({
    method: 'GET',
    url: `/api/chat/vault/shared-media/${userId}`,
    params: {
      page,
      ...options
    }
  })

  const pagination = data?.pagination

  return {
    data: data?.data ?? [],
    nextPage:
      pagination &&
      pagination.current_page < pagination.last_page
        ? pagination.current_page + 1
        : null,
    existingIds: []
  }
}
  export const getAllVaultMediaUnshared = async (
    type: string,
    page: number,
    options: {
      media_type?: string
      grouped?: boolean
      mapExistingPostId?: boolean
      offline?: boolean
      to_user?: string
      unshared_with?: string
      sort?: string
      order?: string
      free_premium_filter?: string
      
    }
  ): Promise<VaultMediaResponse> => {
    const { data } = await axiosInstance({
      method: 'GET',
      url: '/api/user/vault-chat',
      params: {
        type,
        page,
        ...options
      }
    })

    return {
      data: data?.data || [],
      nextPage: data?.next_page ?? null,
      existingIds: options.mapExistingPostId && Array.isArray(data?.data)
        ? data.data.map((item: any) => item.id)
        : []
    }
  }

  export type CategoryStats = {
    id: number
    name?: string
    post_likes: number
    message_purchases: number
    message_conversion_rate: number
  }

  export const getVaultChatCategoryStats = async (
    otherUserId: string
  ): Promise<CategoryStats[]> => {
    const { data } = await axiosInstance({
      method: 'GET',
      url: '/api/user/vault-category-stats',
      params: {
        user_id: otherUserId,
      },
    })
    return data?.data ?? []
  }



export const setDefaultCategory = async (category: string | null) => {
    const { data } = await axiosInstance({
      method: 'POST',
      url: '/api/post/default-category',
      data: {
        category
      }
    });
  
    return data;
  };

export const addMediaToCategory = async (
  categoryId: string,
  posts: string[],
  messages: string[] = [],   // annotate
  stories: string[] = []     // annotate
) => {
  const { data } = await axiosInstance({
    method: 'POST',
    url: '/api/post/add-vault-to-media-category',
    data: {
      category_id: categoryId,
      posts,
      messages,
      stories,
    },
  })
  return data
}

  export const removeMediaFromCategory = async (
    categoryId: any,
    postIds: any,
    messageVaultIds: any,
    storyIds = []
  ) => {
    const { data } = await axiosInstance({
      method: 'POST',
      url: '/api/user/media-categories/remove-vault-from-media-category',
      data: {
        category_id: categoryId,
        posts: postIds,
        messages: messageVaultIds,
        stories: storyIds, // ← include stories
      },
    })
    return data
  }

  export const deleteFromVault = async (vaultableIds: string[]) => {
    const { data } = await axiosInstance({
      method: 'DELETE',
      url: '/api/user/vault',
      data: {
        ids: vaultableIds
      }
    })
  
    return data
  }